module.exports = __webpack_public_path__ + "static/shimza-17e53a979c0c2da771a216b411540a61.jpg";